import apiService from "../../service/apiService";
import newcustomer from "@/constants/newcustomer";
import {cloneDeep} from "lodash";
import moment from "moment/moment";
import URL from "@/constants/baseurl";

export default {
    namespaced: true,
    state: () => ({
        tasks: [],
        branch_pending_tasks:[],

        branch_task_filters:{
            branch_id:'',

            status:'',



            page:1,


        }


    }),
    mutations: {
        SET_BRANCH_PENDING_TASKS(state, tasks) {
            state.branch_pending_tasks = tasks;
        },
        SET_TASKS(state, tasks) {
            state.tasks = tasks;

        }


    },
    actions: {

        async get_branch_pending_tasks({ commit }) {
            const user = JSON.parse(localStorage.getItem('user'));

            if (!user.permissions.includes('super')) {
                const branch_id = user.branch_id;
                const { data } = await apiService.get(`/get-branch-pending-tasks/${branch_id}`);
                commit('SET_BRANCH_PENDING_TASKS', data);
            }
        },
        set_tasks({ commit }, data) {
            commit('SET_TASKS', data);
        },

        async get_tasks({ state, commit }) {
            let user = JSON.parse(localStorage.getItem('user'));
            const apiToken = localStorage.getItem('token');
            const url = `${URL.BASEURL}/api/get-tasks`;

            let filters = {
                status: state.branch_task_filters.status,
                page: state.branch_task_filters.page,
            };

            if (user.permissions.includes('super')) {
                filters.branch_id = state.branch_task_filters.branch_id;
            } else {
                filters.branch_id = user.branch.id;
            }

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify(filters)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const res = await response.json();
                commit('SET_TASKS', res);
            } catch (error) {
                console.error('Error fetching tasks:', error);
            }
        }





    },
    getters: {}
}
